import React from 'react'
import classNames from 'classnames'
import { IconButton } from 'shared/ui/IconButton/ui/IconButton'
import type { ITooltipProps } from 'shared/ui/Tooltip/ui/Tooltip'
import type { ZIndex } from 'shared/constants/zIndex'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'
import type { IToast } from 'shared/ui'
import styles from '../styles.module.scss'

type IIconCopyProps = {
  value: string | number | undefined
  tooltipProps?: ITooltipProps
  showTooltip?: boolean
  show?: boolean
  onClose?: () => void
  onOpen?: () => void
  zIndex?: ZIndex
  className?: string
  toastTitle?: string
  toastType?: IToast['type']
}

export const IconCopyButton: React.FC<IIconCopyProps> = ({
  value,
  showTooltip = false,
  show = true,
  onClose,
  onOpen,
  tooltipProps,
  zIndex,
  className,
  toastTitle,
  toastType,
}) => {
  const { onCopy } = useCopyToClipboard(value, {
    showToast: true,
    mode: 'stateless',
    toastTitle,
    toastType,
  })

  const tooltipInfo: ITooltipProps = {
    label: 'Copy',
    placement: 'top',
    disableInteractive: true,
    onClose: onClose || (() => {}),
    onOpen: onOpen || (() => {}),
    zIndex,
    ...(tooltipProps && tooltipProps),
  }

  return (
    <div
      className={classNames(styles.rightIcon, className, {
        [styles.hidden]: !show,
      })}
    >
      <IconButton
        icon='copy'
        variant='icon'
        color='secondary'
        size='small'
        fontSize={16}
        onClick={onCopy}
        tooltipProps={showTooltip ? tooltipInfo : undefined}
        ariaLabel='IconCopyButton'
      />
    </div>
  )
}
